import { useLang } from '@/i18n';
import EfCardsAppB from '@elem/ui/ef-cards-app-b';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.ListB');
    const listA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724581589584/Monitoring_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724581640573/Monitoring_h5.png',
            title: t('a_title'),
            desc: t('a_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724582245540/pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724582240200/h5.png',
            title: t('b_title'),
            desc: t('b_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724582396639/pc-tuya.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724582408466/h5-tuya.png',
            title: t('c_title'),
            desc: t('c_desc'),
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection label={t('label')} title={t('title')} />
            <EfCardsAppB list={listA} />
        </div>
    );
}
